import React from 'react';

import { faUserHardHat } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

import StrongTextField from '../components/StrongTextField';

export default {
  title: 'Promoteurs',
  name: 'promoteurs',
  icon: faUserHardHat,
  resource: 'promoteur',
  primaryKey: 'idpromoteur',
  head: {
    marque: 'Marque',
    nom: 'Nom',
    entite: 'Entité',
    contact_administratif: 'Dirigeant',
    tel_contact_administratif: 'Téléphone',
    email_contact_administratif: 'Email',
  },
  list: ({ values }) => [
    <Link to={{ pathname: `/i9/promoteurs/${values.idpromoteur}` }}>{values.marque}</Link>,
    <Link to={{ pathname: `/i9/promoteurs/${values.idpromoteur}` }}>{values.nom}</Link>,
    values.entite,
    values.contact_administratif,
    values.tel_contact_administratif,
    values.email_contact_administratif,
  ],
  filter: ({ values, props }) => [
    <StrongTextField name='nom' label='Nom' value={values.nom} {...props} />,
    <StrongTextField name='cp' label='Code postal' value={values.cp} {...props} />,
  ],
  csv: values => [
    values.marque,
    values.nom,
    values.entite,
    values.contact_administratif,
    values.tel_contact_administratif,
    values.email_contact_administratif,
  ],
  add: true,
  show: true,
  remove: true,
};
